export const BASE_URL = process.env.REACT_APP_API_BASE_URL;
// export const BASE_URL = 'http://144.126.143.140:5000/';